import { render, staticRenderFns } from "./SettingsAddressbookSharee.vue?vue&type=template&id=41546450&"
import script from "./SettingsAddressbookSharee.vue?vue&type=script&lang=js&"
export * from "./SettingsAddressbookSharee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports